<!--
 * @Description: 其他收款
 * @Author: luzx
 * @Date: 2023-08-21 14:09:06
 * @LastEditors: hexy 913752270@qq.com
 * @LastEditTime: 2026-07-03 09:32:35
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <div class="header_right" @click="showCardNav = !showCardNav">
        <div class="title">搜索</div>
        <div>
          <div :class="{ arrowTransform: !showCardNav, arrowTransformReturn: showCardNav }">
            <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
          </div>
        </div>
      </div>
      <div v-show="showCardNav" class="hr"></div>
      <el-collapse-transition>
        <div v-show="showCardNav">
          <div class="search">
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 70px; text-align: right">日期 ：</span>
              <el-date-picker v-model="startTimDateEndTimDate" type="daterange" unlink-panels value-format="yyyy-MM-dd"
                start-placeholder="开始时间" end-placeholder="结束时间"
                @change="(tableParam.payeeTimeStart = startTimDateEndTimDate ? startTimDateEndTimDate[0] : ''), (tableParam.payeeTimeEnd = startTimDateEndTimDate ? startTimDateEndTimDate[1] : '')"></el-date-picker>
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 70px; text-align: right">客户单位</span>
              <el-input v-model="tableParam.customerUnit" style="width: 200px" clearable placeholder="请输入" />
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 90px; text-align: right">合同签订主体</span>
              <el-select v-model="tableParam.payeeContractSubjectId" style="width: 200px" filterable clearable
                placeholder="请选择">
                <el-option v-for="(item, index) in mainList" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 70px; text-align: right">收款类型</span>
              <el-select v-model="tableParam.payeeMethodId" style="width: 200px" filterable clearable placeholder="请选择">
                <el-option v-for="(item, index) in piaojuList" :key="index" :label="item.itemName"
                  :value="item.id"></el-option>
              </el-select>
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 70px; text-align: right">收款形式：</span>
              <el-select v-model="tableParam.payeeTypeId" style="width: 300px" placeholder="请选择" clearable>
                <el-option v-for="(item, index) in shoukuanList" :key="index" :label="item.itemName"
                  :value="item.id"></el-option>
              </el-select>
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 150px; text-align: right">收款行及金融工具：</span>
              <el-select v-model="tableParam.payeeBandId" filterable style="width: 300px" placeholder="请选择" clearable>
                <el-option v-for="(item, index) in shoukuanandmonList" :key="index" :label="item.itemName"
                  :value="item.id"></el-option>
              </el-select>
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 70px; text-align: right">收款金额：</span>
              <el-input v-model="tableParam.collectMoneyStart" style="width: 200px" clearable
                placeholder="请输入" />至<el-input v-model="tableParam.collectMoneyEnd" style="width: 200px" clearable
                placeholder="请输入" />
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 70px; text-align: right">票号：</span>
              <el-input v-model="tableParam.billNumber" style="width: 200px" clearable placeholder="请输入" />
            </span>
            <span style="display: inline-block; margin-bottom: 10px">
              <el-button icon="el-icon-search" size="medium" class="bottom_all"
                @click="(tableParam.page = 1), gettableDataex()">查 询</el-button>
              <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
            </span>
          </div>
        </div>
      </el-collapse-transition>
      <div class="hr"></div>
      <div class="card_nav">
        <div style="display: flex; align-items: center">
          <el-button size="small" class="bottom_all" style="margin-left: 0" @click="addcard"> 添加 </el-button>
          <el-button size="small" class="bottom_two" @click="delHandler"> 删除 </el-button>
          <div style="margin-left: 10px; color: red; font-weight: bold"><span style="">合计金额：</span>{{ tableData[0] ?
            (tableData[0].totalMoney ? numFormat(tableData[0].totalMoney) : 0) : 0 }} 元</div>
        </div>
        <div>
          <el-button size="medium" class="bottom_all" style="margin-left: 12px" @click="load()">导 出</el-button>
        </div>
      </div>
      <el-main style="display: flex">
        <div>
          <!-- <div class="card scroll"> -->
          <div class="card overheight">
            <!-- { background: '#f3f6f9' } -->
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table :header-cell-style="setTitle" :cell-style="{ borderRight: 'none' }" border stripe
                style="width: 100%" :data="tableData" tooltip-effect="dark" :height="overheight"
                @selection-change="handleSelectionChange">
                <el-table-column align="center" type="selection"></el-table-column>
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                    :min-width="item.width" :fixed="item.label == '操作' ? 'right' : false">
                    <template slot-scope="scope">
                      <span v-if="item.label == '状态'">
                        <span v-if="scope.row.dataStatus == 0" style="color: #969799">未开票</span>
                        <span v-if="scope.row.dataStatus == 1" style="color: #00a754">已开票</span>
                      </span>
                      <span v-else-if="item.label == '票据状态'">
                        <span v-if="scope.row.billStatus == 0" style="color: #969799">普通票据</span>
                        <span v-if="scope.row.billStatus == 1" style="color: #00a754">已支付</span>
                        <span v-if="scope.row.billStatus == 2" style="color: #00a754">已支付完成</span>
                        <span v-if="scope.row.billStatus == 3" style="color: #00a754">已贴现</span>
                        <span v-if="scope.row.billStatus == 4" style="color: #2ac5ec">已兑付</span>
                      </span>
                      <span v-else-if="item.label == '票据终止状态'">
                        <span v-if="scope.row.billStopStatus == 0" style="color: #00a754"></span>
                        <span v-if="scope.row.billStopStatus == 1" style="color: #00a754">已贴现</span>
                        <span v-if="scope.row.billStopStatus == 2" style="color: #2ac5ec">已兑付</span>
                      </span>
                      <span v-else-if="item.label == '集团内'">
                        <span v-if="scope.row.whetherGroup == 0" style="color: #969799">否</span>
                        <span v-else-if="scope.row.whetherGroup == 1" style="color: #00a754">是</span>
                      </span>
                      <span v-else-if="item.label == '流程'">
                        <span v-if="scope.row.flowPath == 0" style="color: #969799">流程未走完</span>
                        <span v-if="scope.row.flowPath == 1" style="color: #00a754">流程已走完</span>
                      </span>
                      <span v-else-if="item.label == '是否认领'">
                        <span style="color: #969799">{{ ["流水待认领", "流水未认领完", "流水已认领，流程中", "流水已认领",
                          "已完结"][scope.row.claimStatus] }}</span>
                      </span>
                      <div v-else-if="item.label == '操作'">
                        <el-button class="bottom_one" size="mini" @click="lookcard(scope.row)"> 修改 </el-button>
                      </div>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper" :total="total"
            @size-change="sizeChange" @current-change="gettableDataex()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
            @click="gettableDataex">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- <diaLog1 :dialog="dialog1" :low="low" @reset="reset" @submit="submit"></diaLog1> -->
    <el-dialog :title="titleName" :visible.sync="dialog" width="1000px" :close-on-click-modal="false">
      <div>
        <el-form ref="formDate" :rules="rules" :model="formDate" :inline="true" label-width="160px">
          <!-- <el-form-item label="月份：" prop="payeeYearMonth">
            <el-date-picker v-model="formDate.payeeYearMonth" type="month" style="width: 300px" value-format="yyyy-MM"
              placeholder="选择月"> </el-date-picker>
          </el-form-item>
          <el-form-item label="时间：" prop="payeeTime">
            <el-date-picker v-model="formDate.payeeTime" type="date" style="width: 300px" value-format="yyyy-MM-dd"
              placeholder="选择日期"> </el-date-picker>
          </el-form-item> -->
          <el-form-item label="时间：" prop="payeeTime">
            <el-date-picker v-model="formDate.payeeTime" type="date" style="width: 300px" value-format="yyyy-MM-dd"
              placeholder="选择日期" @change="handleTimeChange"> </el-date-picker>
          </el-form-item>
          <el-form-item label="月份：" prop="payeeYearMonth">
            <el-date-picker v-model="formDate.payeeYearMonth" type="month" style="width: 300px" value-format="yyyy-MM"
              placeholder="选择月" disabled> </el-date-picker>
          </el-form-item>
          <el-form-item label="收款形式：" prop="payeeTypeId">
            <el-select ref="shoukuanList" v-model="formDate.payeeTypeId" style="width: 300px" placeholder="请选择" @change="
              changestatus(),
              $nextTick(() => {
                formDate.payeeType = $refs.shoukuanList.selectedLabel;
              })
              ">
              <el-option v-for="(item, index) in shoukuanList" :key="index" :label="item.itemName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收款行及金融工具：" prop="payeeBandId">
            <el-select ref="shoukuanandmonList" v-model="formDate.payeeBandId" filterable style="width: 300px"
              placeholder="请选择" @change="
                $nextTick(() => {
                  formDate.payeeBand = $refs.shoukuanandmonList.selectedLabel;
                })
                ">
              <el-option v-for="(item, index) in shoukuanandmonList" :key="index" :label="item.itemName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户单位：" prop="customerUnit">
            <el-input v-model="formDate.customerUnit" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item label="收款：" prop="payeeMoney">
            <el-input v-model="formDate.payeeMoney" style="width: 300px" clearable placeholder="请输入" maxlength="12"
              @change="collectMoneyChange">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="单据号：" prop="shareDocumentNumber">
            <el-input v-model="formDate.shareDocumentNumber" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item label="凭证号：" prop="voucherNumber">
            <el-input v-model="formDate.voucherNumber" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item label="主体：" prop="payeeSubjectId">
            <el-select v-model="formDate.payeeSubjectId" style="width: 300px" filterable placeholder="请选择"
              @change="changeCollaborat()">
              <el-option v-for="(item, index) in mainListBodys" :key="index" :label="item.itemName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合同签订主体：" prop="payeeContractSubjectId">
            <el-select ref="payUnit" v-model="formDate.payeeContractSubjectId" style="width: 300px" filterable
              placeholder="请选择" @change="
                $nextTick(() => {
                  formDate.payeeContractSubject = $refs.payUnit.selectedLabel;
                })
                ">
              <el-option v-for="(item, index) in mainList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收款类型：" prop="payeeMethodId">
            <el-select ref="billType" v-model="formDate.payeeMethodId" filterable style="width: 300px" placeholder="请选择"
              @change="
                $nextTick(() => {
                  formDate.payeeMethod = $refs.billType.selectedLabel;
                })
                ">
              <el-option v-for="(item, index) in piaojuList" :key="index" :label="item.itemName" :value="item.id"
                @click.native="addCodeRule(item)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="formDate.payeeMethod == '收贴现款' || formDate.payeeMethod == '收兑付款'" label="票号："
            prop="billNumber">
            <el-select v-model="formDate.billNumber" filterable style="width: 300px" placeholder="请选择">
              <el-option v-if="selectLoad" :key="'loading'" label="加载中..." disabled></el-option>
              <template v-else>
                <el-option v-for="(item, index) in ticketNoList" :key="index" :label="item.tiketNumber + '-' + item.type"
                  :value="item.tiketNumber" @click.native="addCodeRule1(item)"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item v-if="formDate.payeeMethod == '收贴现款' || formDate.payeeMethod == '收兑付款'" label="手续费："
            prop="serviceFee">
            <el-input v-model="formDate.serviceFee" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item v-if="formDate.payeeMethod == '收票据'" label="票号：" prop="billNumber">
            <el-input v-model="formDate.billNumber" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item v-if="formDate.payeeMethod == '收票据'" label="出票日期：" prop="issueDate">
            <el-date-picker v-model="formDate.issueDate" type="date" style="width: 300px" value-format="yyyy-MM-dd"
              placeholder="选择日期"> </el-date-picker>
          </el-form-item>
          <el-form-item v-if="formDate.payeeMethod == '收票据'" label="到期日期：" prop="dueDate">
            <el-date-picker v-model="formDate.dueDate" type="date" style="width: 300px" value-format="yyyy-MM-dd"
              placeholder="选择日期"> </el-date-picker>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input v-model="formDate.payeeRemark" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="addcardSure('formDate')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
<script>
import mixin from "@/mixins/ICPSmixin.js";
import { formatTreeData } from "@/utils/utils";
import { querysupplierPage } from "@/api/GHnumber/supplier.js";
// import { getDicsType } from "@/api/common.js";
// import { getUserInfo } from "@/utils/auth"
import { queryPage, Download, get_list_by_type, saveOrUpdate, get_detail_code, deleteNotes,getOtherBill } from "@/api/internetSales/otherReceipts.js";
import { post } from "@/api/table.js";
export default {
  mixins: [mixin],
  data() {
    return {
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      DownloadURL: Download,
      batchUpdateOrDelete: deleteNotes,
      /*表格数据*/
      table: [
        { label: "收款编号", width: "120", prop: "id", status: true },
        { label: "票据状态", width: "120", prop: "billStatus", status: true },
        { label: "票据终止状态", width: "120", prop: "billStopStatus", status: true },
        { label: "票号", width: "120", prop: "billNumber", status: true },
        { label: "手续费", width: "120", prop: "serviceFee", status: true },
        { label: "年月", width: "140", prop: "payeeYearMonth", status: true },
        { label: "日期", width: "140", prop: "payeeTime", status: true },
        { label: "收款形式", width: "140", prop: "payeeType", status: true },
        { label: "收款行及金融工具", width: "120", prop: "payeeBand", status: true },
        { label: "客户单位", width: "300", prop: "customerUnit", status: true },
        { label: "收款（元）", width: "120", prop: "payeeMoney", status: true },
        { label: "单据号", width: "120", prop: "shareDocumentNumber", status: true },
        { label: "凭证号", width: "120", prop: "voucherNumber", status: true },
        { label: "主体", width: "300", prop: "payeeSubject", status: true },
        { label: "合同签订主体", width: "300", prop: "payeeContractSubject", status: true },
        { label: "收款类型", width: "120", prop: "payeeMethod", status: true },
        { label: "出票日期", width: "120", prop: "issueDate", status: true },
        { label: "到期时间", width: "120", prop: "dueDate", status: true },
        { label: "备注", width: "240", prop: "payeeRemark", status: true },
        { label: "操作", width: "240", prop: "", status: true },
      ],
      pagesType: 0,
      dialog: false,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      disabled: false,
      modifyType: false,
      low: {},
      rules: {
        payeeYearMonth: [{ required: true, message: "请选择年月", trigger: "change" }],
        payeeTime: [{ required: true, message: "请选择时间", trigger: "change" }],
        payeeTypeId: [{ required: true, message: "请选择收款形式", trigger: "change" }],
        payeeBandId: [{ required: true, message: "请选择收款行及金融工具", trigger: "change" }],
        customerUnit: [{ required: true, message: "请填写客户单位", trigger: "change" }],
        payeeMoney: [{ required: true, message: "请输入收款", trigger: "change" }],
        payeeSubjectId: [{ required: true, message: "请选择主体", trigger: "change" }],
        payeeContractSubjectId: [{ required: true, message: "请选择合同订单主体", trigger: "change" }],
        payeeMethodId: [{ required: true, message: "请选择收款类型", trigger: "change" }],
        billNumber: [{ required: true, message: "请选择票号", trigger: "change" }],
        issueDate: [{ required: true, message: "请选择出票日期", trigger: "change" }],
        dueDate: [{ required: true, message: "请选择到期日期", trigger: "change" }],
      },
      engineeringNameList: [], //工程名称列表
      invoicedAmount: "", //
      files: [],
      claimList: [
        { name: "流水待认领", id: 0 },
        { name: "流水未认领完", id: 1 },
        { name: "流水已认领，流程中", id: 2 },
        { name: "流水已认领", id: 3 },
        { name: "已完结", id: 4 },
      ], //是否认领列表
      mainList: [], //主体列表

      costMoneyInitData: [],
      payerUnitParams: {
        page: 1,
        pageSize: 10,
        payerUntiName: "",
      },
      totalpayerUnit: 0,
      tablepayerUnit: [],
      addPayerUnit: {
        payerUntiName: "",
        whetherGroup: 0,
      },
      payerUnitNoPage: [],
      formDate: {
        payeeYearMonth: "",
        payeeTime: "",
        payeeTypeId: "",
        payeeType: "",
        payeeBandId: "",
        payeeBand: "",
        supplierUnit: "",
        payeeMoney: "",
        payeeSubject: "",
        payeeSubjectId: "",
        payeeContractSubject: "",
        payeeContractSubjectId: "",
        payeeMethod: "",
        payeeMethodId: "",
        payeeRemark: "",
        serviceFee: "",
        billNumber: "",
        customerUnit: "",
        shareDocumentNumber:"", //共享单据号
        voucherNumber:"", //凭证号
      },
      shoukuanList: [],
      shoukuanandmonList: [],
      shoukuanandmonList1: [],
      shoukuanandmonList2: [],
      piaojuList: [],
      ticketNoList: [],
      recourseTransferList: [
        { name: "无追可转", id: "1" },
        { name: "无追不可转", id: "2" },
        { name: "可追可转", id: "3" },
        { name: "可追不可转", id: "4" },
      ],
      contractProcessList: ["合同已收", "流程已收"],
      collectionMethodList: [
        { name: "合同约定", id: "1" },
        { name: "流程审核", id: "2" },
      ],
      editFlag: false,
      options: [],
      isMust: true,
      isMust2: true,
      isMust3: true,
      titleName: "添加",
      collectClaimList: [], //认领列表
      renlingId: "",
      treeArry: [],
      organizationList: [],
      userList: [],
      userNameList: [],
      sendFlag: true,
      loadingSaller: false,
      overheight: 400,

      mainListBodys: [],
      supplierList: [],
      startTimDateEndTimDate: [],
      selectLoad: false,
    };
  },
  watch: {
    startTimDateEndTimDate(val) {
      if (val?.length > 0) {
        this.tableParam.payeeTimeStart = val[0];
        this.tableParam.payeeTimeEnd = val[1];
      } else {
        this.tableParam.payeeTimeStart = "";
        this.tableParam.payeeTimeEnd = "";
      }
    },
  },
  created() {
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam = {
      ...this.tableParam,
      payeeMethodId: "",
      customerUnit: "",
      payeeContractSubjectId: "",
      payeeTime: "",
      payeeTypeId: "",
      payeeBandId: "",
      collectMoneyStart: "",
      collectMoneyEnd: "",
      payeeTimeStart: "",
      payeeTimeEnd: "",
      billNumber: "",
    };
    this.gettableDataex();
    this.get_list_by_type();
    this.get_detail_code();
    this.initOrganization();
    console.log("document.body.scrollWidth", document.body.scrollHeight);
    this.overheight = document.body.scrollHeight - 560;

    let params = {
      page: 1,
      pageSize: 99999,
      enable: 1,
    };
    querysupplierPage(params).then(res => {
      this.supplierList = res.data.data;
    });
  },
  mounted() { },
  methods: {
    addCodeRule1(item) {
      this.formDate.billStopStatus = 0
      if (this.formDate.payeeMethod == '收贴现款') {
        if (item.type == '其他收款') {
          this.formDate.billStopStatus = 1
        }
      }
      if (this.formDate.payeeMethod == '收兑付款') {
        if (item.type == '其他收款') {
          this.formDate.billStopStatus = 2
        }
      }
    },
    addCodeRule(item) {
      console.log("=======================")
      if (item.id != "346377779937415168" || item.id != "343852716453400576" || item.id != "450471299966439424") {
        //   // 定义规则
        // const newRules = [{ required: true, trigger: "change", message: "具体活动必填" }];
        // // 给rules对象添加规则
        // this.rules = { ...this.rules, billNumber: newRules };
        // 清除指定校验规则
        // this.$refs.form.clearValidate(["billNumber"]);
        // 这行必须
        this.rules = { ...this.rules, billNumber: [] };
        this.formDate.billNumber = "";
        this.formDate.serviceFee = "";
      }
      if (item.id != "450471299966439424") {
        this.rules = { ...this.rules, issueDate: [], dueDate: [] };
      }
      console.log(this.formDate)
    },
    // 监听时间变化，自动带入月份
    handleTimeChange(val) {
      if (val) {
        // val 的格式是 "yyyy-MM-dd"，直接截取前7位得到 "yyyy-MM"
        this.formDate.payeeYearMonth = val.slice(0, 7);
      } else {
        // 如果清空了时间，月份也同步清空
        this.formDate.payeeYearMonth = "";
      }
    },
    collectMoneyChange(e) {
      console.log(e);
      this.formDate.payeeMoney = this.numFormat(e);
      console.log(this.formDate.payeeMoney);
    },
    claimMoneyChange(i, v) {
      console.log(i);
      console.log(v);
      v.claimMoney = this.numFormat(v.claimMoney);
      this.$set(this.collectClaimList, i, this.collectClaimList[i]);
    },
    numFormat(num) {
      var res = num.toString().replace(/\d+/, function (n) {
        // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
          return $1 + ",";
        });
      });
      return res;
    },
    commafybackTY(num) {
      var x = num.split(",");
      return parseFloat(x.join(""));
    },
    structuralPartsCheckFun() {
      // this.formDate.contractProcess = "";
      let item = this.contractProcessList.find(v => v.id == this.formDate.contractProcess);
      console.log(item);
      // if (item) {
      //     this.formDate.strengthGradeId = JSON.parse(item.strengthGrade)[0].id;
      //     if (item.performanceGrade) {
      //         this.formDate.performanceGradeIdList = JSON.parse(item.performanceGrade).map(v => v.id);
      //     }
      //     if (item.meterialRequirements) {
      //         this.formDate.meterialRequirementsIdList = JSON.parse(item.meterialRequirements).map(v => v.id);
      //     }
      //     if (item.specialRequirements) {
      //         this.formDate.specialRequirementsIdList = JSON.parse(item.specialRequirements).map(v => v.id);
      //     }
      //     if (item.otherRequirements) {
      //         this.formDate.otherRequirementsIdList = JSON.parse(item.otherRequirements).map(v => v.id);
      //     }
      //     if (item.admixtureRequirements) {
      //         this.formDate.admixtureRequirementsIdList = JSON.parse(item.admixtureRequirements).map(v => v.id);
      //     }
      // }
    },
    /**
     * @Description: 获取所有组织和用户、格式化tree结构
     * @Param:
     * @Author: wangwangwang
     */
    initOrganization() {
      /* 
              把计算缓慢的数据暂时隐藏
            */
      // const { state } = this.$store;
      // if (!state.approvePerson.orgList || !state.approvePerson.userList) {
      //   console.log("---------user----------");
      //   const orgPromise = this.$store.dispatch("approvePerson/getorg");
      //   const userPromise = this.$store.dispatch("approvePerson/getuser");
      //   this.loading = true;
      //   Promise.all([orgPromise, userPromise])
      //     .then(([orgres, userres]) => {
      //       this.formatDataSource(orgres, userres);
      //     })
      //     .catch(e => console.log(e));
      // } else {
      //   this.formatDataSource(state.approvePerson.orgList, state.approvePerson.userList);
      // }
      const orgPromise = localStorage.getItem("setPersonOrg") ? JSON.parse(localStorage.getItem("setPersonOrg")) : this.$store.dispatch("approvePerson/getorg");
      const userPromise = localStorage.getItem("setPersonUser") ? JSON.parse(localStorage.getItem("setPersonUser")) : this.$store.dispatch("approvePerson/getuser");
      this.loading = true;
      Promise.all([orgPromise, userPromise])
        .then(([orgres, userres]) => {
          console.log("orgres", orgres);
          console.log("userres", userres);
          this.formatDataSource(orgres, userres);
        })
        .catch(e => console.log(e));
    },
    formatDataSource(orgList, userList) {
      orgList.forEach(v => {
        v.type = 2;
      });
      this.organizationList = formatTreeData(orgList, "id", "parentId", "children", "parent_id");
      if (!userList) {
        userList = [];
      }
      userList.forEach(v => {
        v.type = 1;
      });
      const newArry = userList.map(item => ({
        ...item,
        parentId: item.organizationId,
      }));
      this.userList = userList;
      /* 
              把计算缓慢的数据暂时隐藏
            */
      let storageUserList = []; //缓存的用户数据
      this.$forage.getItem("orgListData").then(val => {
        storageUserList = val;
      });
      console.log(storageUserList);
      if (storageUserList?.length > 0) {
        this.allData = storageUserList;
        this.treeArry = storageUserList;
        console.log("this.treeArry", this.treeArry);
      } else {
        let arr = formatTreeData(orgList.concat(newArry), "id", "parentId", "children", "parent_id");
        this.allData = arr;
        this.treeArry = arr;
        this.$forage.setItem("orgListData", arr).then(val => {
          console.log(val);
        });
        console.log("this.treeArry", this.treeArry);
      }
      // this.treeArry = formatTreeData(
      //   orgList.concat(newArry),
      //   "id",
      //   "parentId",
      //   "children",
      //   "parent_id"
      // );
      // this.allData = formatTreeData(
      //   orgList.concat(newArry),
      //   "id",
      //   "parentId",
      //   "children",
      //   "parent_id"
      // );
      this.loading = false;
    },
    delItem1(i) {
      console.log(i);
      this.collectClaimList.splice(i, 1);
    },
    userChooseChange(e) {
      console.log(e);
    },
    setTitle() {
      // const columnIndex = row.columnIndex
      return "background: #f3f6f9;";
    },
    changestatus() {
      console.log(this.formDate.payeeTypeId);
      var arrChoose = this.shoukuanList.filter(e => {
        if (e.id == this.formDate.payeeTypeId) {
          return true;
        }
      });
      this.$nextTick(() => {
        if (arrChoose[0].itemName == "银行存款") {
          this.isMust = false;
          this.isMust3 = false;
          this.isMust2 = true;
          this.$refs["formDate"].clearValidate();
        } else if (arrChoose[0].itemName == "抵款" || arrChoose[0].itemName == "其他") {
          this.isMust = false;
          this.isMust2 = false;
          this.isMust3 = false;
          this.$refs["formDate"].clearValidate();
        } else if (arrChoose[0].itemName == "银行承兑" || arrChoose[0].itemName == "商业承兑") {
          this.isMust = true;
          this.isMust2 = true;
          this.isMust3 = false;
        } else {
          this.isMust = true;
          this.isMust2 = true;
          this.isMust3 = true;
        }
        if (arrChoose[0].itemName == "供应链金融产品") {
          this.shoukuanandmonList = JSON.parse(JSON.stringify(this.shoukuanandmonList2));
          this.formDate.payeeBandId = "";
        } else {
          this.shoukuanandmonList = JSON.parse(JSON.stringify(this.shoukuanandmonList1));
          this.formDate.payeeBandId = "";
        }
        // if (arrChoose[0].itemName == '银行承兑' || arrChoose[0].itemName == '商业承兑') {
        //     this.piaojuList.forEach(e => {
        //         if (e.itemName == arrChoose[0].itemName) {
        //             this.formDate.payeeMethodId = e.id
        //         }
        //     })
        // }
      });
    },
    initaddPayer() {
      this.addPayerUnit = this.$options.data().addPayerUnit;
    },
    /*获取列表*/
    async gettableDataex() {
      this.tableLoading = true;
      await post(this.queryPage, this.tableParam).then(res => {
        if (res.code === 1001) {
          this.tableLoading = false;
          this.total = res.data.totalRows;
          this.tableData = res.data.data;
          // this.reChange()
          this.copyDataSource = JSON.parse(JSON.stringify(res.data.data));
        }
      });
    },
    /* 获取主体 */
    get_list_by_type() {
      get_list_by_type({ typeId: "19da56b9e85648059e3cf1e7da497da4" }).then(res => {
        if (res.code == 1001) {
          this.mainList = res.data;
        }
      });
    },
    /* 获取字典 */
    get_detail_code() {
      get_detail_code({ codes: "SHOUKUANXINGSHI,SHOUKUANHANG1,SHOUKUANHANG4,CollectionType,engineeringMainBody" }).then(res => {
        if (res.code == 1001) {
          console.log(res.data);
          this.shoukuanList = res.data["SHOUKUANXINGSHI"].items;
          this.shoukuanandmonList1 = res.data["SHOUKUANHANG1"].items;
          this.shoukuanandmonList = res.data["SHOUKUANHANG1"].items;
          this.shoukuanandmonList2 = res.data["SHOUKUANHANG4"].items;
          this.piaojuList = res.data["CollectionType"].items;
          this.mainListBodys = res.data["engineeringMainBody"].items;
        }
      });
      this.selectLoad = true
      getOtherBill().then(res => {
      if(res.code == 1001) {
        this.ticketNoList = res.data
      }
      this.selectLoad = false
     }).catch(() => {
            this.selectLoad = false
           });
      // queryPageTicket({ page: 1, pageSize: 99999 }).then(res => {
      //   if (res.code == 1001) {
      //     let newArr = res.data.data
      //       .filter(item => item.tiketNumber !== null && item.tiketNumber !== "" && item.tiketNumber !== undefined)
      //       .map(item => ({ tiketNumber:item.tiketNumber, tocketType: '工程收款' }));
      //        // 根据 tiketNumber 去重
      //        const seen = new Set();
      //         const uniqueNewArr = newArr.filter(item => {
      //           if (seen.has(item.tiketNumber)) {
      //             return false;
      //           } else {
      //             seen.add(item.tiketNumber);
      //             return true;
      //           }
      //         });
      //     queryPageOtherTicket({ page: 1, pageSize: 99999 }).then(res2 => {
      //       if (res2.code == 1001) {
      //         let newArr2 = res2.data.data
      //           .filter(item => item.billNumber !== null && item.billNumber !== "" && item.billNumber !== undefined && item.payeeMethod == '收票据')
      //           .map(item => ({ tiketNumber: item.billNumber, tocketType: '其他收款' }));
      //         // 根据 tiketNumber 去重
      //         const seen2 = new Set();
      //         const uniqueNewArr2 = newArr2.filter(item => {
      //           if (seen2.has(item.tiketNumber)) {
      //             return false;
      //           } else {
      //             seen2.add(item.tiketNumber);
      //             return true;
      //           }
      //         });

      //         this.ticketNoList = [...uniqueNewArr, ...uniqueNewArr2];
      //         this.selectLoad = false
      //       }
      //     }).catch(() => {
      //       this.selectLoad = false
      //     });
      //   }
      // }).catch(() => {
      //   this.selectLoad = false
      // });

    },
    reChange() {
      let arr = [];
      this.tableData.forEach(e => {
        if (e.collectMoney) {
          e.collectMoney = this.numFormat(e.collectMoney);
        }

        if (e.collectMoneyClaimList.length > 0) {
          let length = e.collectMoneyClaimList.length;
          e.collectMoneyClaimList.forEach((m, n) => {
            if (m.claimMoney) {
              m.claimMoney = this.numFormat(m.claimMoney);
            }
            m.id = e.id;
            if (n === 0) {
              arr.push({ ...e, ...m, rowspan: length, colspan: 1 });
            } else {
              arr.push({ ...e, ...m, rowspan: 0, colspan: 0 });
            }
          });
        } else {
          arr.push({ ...e, rowspan: 1, colspan: 1 });
        }
      });
      this.tableData = arr;
    },
    changeCollaborat() {
      var arrChoose = this.mainListBodys.filter(e => {
        if (e.id == this.formDate.payeeSubjectId) {
          return true;
        }
      });
      console.log(arrChoose);
      this.formDate.payeeSubject = arrChoose[0].itemName;
    },
    changePayeeAccount() {
      var arrChoose = this.mainList.filter(e => {
        if (e.id == this.formDate.payeeAccountId) {
          return true;
        }
      });
      this.formDate.payeeAccount = arrChoose[0].name;
    },
    addcardSure(formName) {
      console.log(this.formDate);
      // if(!this.editFlag){
      //     return;
      // }
      // let data = { ...this.low, invoiceAssembleAmount: this.invoicedAmount };
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.formDate.payeeMoney) {
            this.formDate.payeeMoney = this.commafybackTY(this.formDate.payeeMoney);
          }
          // if (payeeMethodId!== "346377779937415168" || payeeMethodId!== "343852716453400576") {
          //   // this.formDate.billNumber = "";
          //   // this.formDate.serviceFee = "";
          // alert(payeeMethodId)
          // }else if(payeeMethodId== "346377779937415168" || payeeMethodId== "343852716453400576"){
          //   alert(6666)
          // }
          console.log(this.formDate);
          saveOrUpdate(this.formDate).then(res => {
            if (res.code == 1001) {
              this.$message({
                message: "添加成功",
                type: "success",
              });
            }
            this.gettableDataex();
            this.dialog = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /**
     * @Description: 删除附件
     * @Param:
     * @Author: wangwangwang
     */
    deleteFile(index) {
      this.files.splice(index, 1);
    },
    /**
     * @Description: 上传成功
     * @Param:
     * @Author: wangwangwang
     */
    uplodeSuccess(data) {
      this.files.push(data);
    },
    addCollectClaim() {
      let item = {
        engineeringId: "", //工程id
        enginnerrName: "", //工程名
        claimMoney: 0, //认领金额
        flowPath: 1, //流程：0流程未走完；1流程已走完
        collaborationUnit: "", //合同签订主体d
        collaborationUnitId: "", //合同签订主体
        financialCode: "", //财务编码
        saller: "", //销售员
        sallerId: "", //销售员id
        sallerDivision: "", //销售处别
        sallerDivisionId: "", //销售处别id
      };
      this.collectClaimList.push(item);
    },
    addcard() {
      this.formDate = this.$options.data().formDate;
      this.titleName = "添加";
      this.dialog = true;
      this.$nextTick(() => {
        this.$refs["formDate"].clearValidate();
      });
    },
    costMoneyInit() {
      this.dialog1 = true;
    },
    lookcard(row) {
      this.titleName = "修改";
      console.log(row);
      this.formDate = this.copy(row);
      if (this.formDate.payeeMoney) {
        this.formDate.payeeMoney = this.numFormat(this.formDate.payeeMoney);
      }
      if (row.payeeType == "供应链金融产品") {
        this.shoukuanandmonList = this.copy(this.shoukuanandmonList2);
      } else {
        this.shoukuanandmonList = this.copy(this.shoukuanandmonList1);
      }
      this.dialog = true;
      this.$nextTick(() => {
        if (row.payeeType == "银行存款") {
          this.isMust = false;
          this.isMust3 = false;
          this.isMust2 = true;
          this.$refs["formDate"].clearValidate();
        } else if (row.payeeType == "抵款" || row.payeeType == "其他") {
          this.isMust = false;
          this.isMust2 = false;
          this.isMust3 = false;
          this.$refs["formDate"].clearValidate();
        } else if (row.payeeType == "银行承兑" || row.payeeType == "商业承兑") {
          this.isMust = true;
          this.isMust2 = true;
          this.isMust3 = false;
          this.$refs["formDate"].clearValidate();
        } else {
          this.isMust = true;
          this.isMust2 = true;
          this.isMust3 = true;
          this.$refs["formDate"].clearValidate();
        }
      });
    },
    delHandler() {
      if (this.ids.length == 0) {
        this.$message({
          message: "请选择要操作的数据项",
          type: "warning",
        });
        return;
      }
      this.$confirm("此操作将永久删除该信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          post(this.batchUpdateOrDelete, this.ids).then(res => {
            if (res.code == 1001) {
              let page = Math.ceil((this.total - this.ids.length) / this.tableParam.pageSize);
              if (this.tableParam.page > Math.ceil(page / this.tableParam.pageSize)) {
                this.tableParam.page = page;
              }
              this.gettableDataex();
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
          });
        })
        .catch(() => { });
    },
    changstatus(e, row) {
      var chooseArr = this.engineeringNameList.filter(m => {
        if (m.engineeringId == row.engineeringId) {
          return true;
        }
      });

      // this.collectClaimList[e].saller = chooseArr[0].saller
      // this.collectClaimList[e].sallerDivision = chooseArr[0].sallerDivision
      this.collectClaimList[e] = { ...this.collectClaimList[e], ...chooseArr[0] };
      this.collectClaimList[e].enginnerrName = chooseArr[0].engineeringName;
      if (!chooseArr[0].financialCode) {
        this.collectClaimList[e].financialCode = "";
      } else {
        this.collectClaimList[e].financialCode = chooseArr[0].financialCode;
      }
      if (!chooseArr[0].collaborationUnit) {
        this.collectClaimList[e].collaborationUnit = "";
      } else {
        this.collectClaimList[e].collaborationUnit = chooseArr[0].collaborationUnit;
      }
      this.$set(this.collectClaimList, e, this.collectClaimList[e]);
    },
    chooseNav(index) {
      this.currenindex = index;
    },
    open(low, key, disabled) {
      this.low = this.copy(low);
      this.disabled = disabled;
      this[key] = true;
    },
    reset(key) {
      this[key] = false;
    },
    submit(key) {
      this[key] = false;
      this.gettableDataex();
    },
    /*重置数据,此方法必须存在，并且方发只重置条件*/
    init() {
      this.tableParam = {
        ...this.tableParam,
        payeeMethodId: "",
        customerUnit: "",
        payeeContractSubjectId: "",
        payeeTime: "",
        payeeTypeId: "",
        payeeBandId: "",
        collectMoneyStart: "",
        collectMoneyEnd: "",
        payeeTimeStart: "",
        payeeTimeEnd: "",
        billNumber: "",
      };
      this.startTimDateEndTimDate = [];
      this.gettableDataex();
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableDataex();
    },
    objectSpanMethod({ row, columnIndex }) {
      // console.log(column)
      // console.log(rowIndex)
      if (row.rowspan > 1) {
        if (columnIndex !== 10 && columnIndex !== 11 && columnIndex !== 12 && columnIndex !== 13 && columnIndex !== 14 && columnIndex !== 15 && columnIndex !== 16) {
          return {
            rowspan: row.rowspan,
            colspan: row.colspan,
          };
        }
      } else {
        if (columnIndex !== 10 && columnIndex !== 11 && columnIndex !== 12 && columnIndex !== 13 && columnIndex !== 14 && columnIndex !== 15 && columnIndex !== 16) {
          return {
            rowspan: row.rowspan,
            colspan: row.colspan,
          };
        }
      }
    },
  },
};
</script>
  
<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}

.tabtop {
  width: 381px;
}

.bill_title {
  font-size: 18px;
  font-weight: 600;
  padding: 15px 0;
}

.el-select-dropdown__list {
  width: 400px;
}

.boxSaller {
  display: flex;
  flex-wrap: wrap;
}

.sallerItem {
  // width: auto;
  height: 30px;
  background: #c4f0d9;
  // color: #fff;
  text-align: center;
  line-height: 30px;
  align-items: center;
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 0 10px;
}

.search {
  display: flex;
  flex-wrap: wrap;
}
</style>
  